import { useQuery } from "@tanstack/react-query";
import { ProjectResponse } from "../../../types/project";
import { ApiError } from "../../../types/apiError";
import { getProjectsByOrganisation } from "../api/getProjectsByOrganisation";

interface Params {
  organisationUuid?: string | null;
  page?: number;
  size?: number;
  search?: string;
}

export const useProjectsByOrganisationQuery = ({
  organisationUuid,
  page = 0,
  size = 20,
  search
}: Params) =>
  useQuery<ProjectResponse, ApiError>({
    queryKey: ["projects-by-organisation", organisationUuid, page, size, search],
    queryFn: () => {
      if (!organisationUuid) {
        throw new Error("Missing organisationUuid");
      }
      return getProjectsByOrganisation(organisationUuid, page, size, search);
    },
    enabled: Boolean(organisationUuid),
  });
